<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          컬렉션 상세정보
        </div>
        <div class="write_tab">
          <div class="write_tab_content tab_payment_detail active">
            상세정보
          </div>
          <div class="write_tab_content tab_payment_detail"
               @click="moveItem()">
            아이템
          </div>
          <div class="write_tab_content tab_payment_detail"
               @click="moveUtility()">
            유틸리티
          </div>
        </div>
        <div class="member_write_wrap">
          <div class="write_content">
            <div class="write_box">
              <item-write-collection-component :item-type="`collectionDetail`"
                                               :item-key="itemKey"></item-write-collection-component>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ItemWriteComponent from "@/components/item/ItemWriteComponent";
import EventBus from "@/utils/event-bus";
import ItemWriteCollectionComponent from "@/components/item/ItemWriteCollectionComponent";

export default {
  name: "ItemCollectionDetail",
  mixins: [],
  components: {
    ItemWriteCollectionComponent,
    ItemWriteComponent
  },
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      itemKey: this.$route.params.idx
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveItem() {
      this.$router.push(`/item/collection/${this.itemKey}/item`)
    },
    moveUtility() {
      this.$router.push(`/item/collection/${this.itemKey}/utility`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
